import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Explore_Products.css";

import "swiper/css";
import "swiper/css/navigation";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";
import { IDS } from "../../../utils/common";
import { getCropSolutions } from "../../../utils/apis/homepage";

const Explore_Products = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  const navigate = useNavigate();

  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    try {
      const res = await getCropSolutions();

      if (res?.success) {
        setBanner(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching crop solutions:", error);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  const handleProductClick = (vegetable) => {
    navigate("/recommended-products", {
      state: {
        crop: vegetable,
      },
    });
  };

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <section className="explore_products">
      <div className="container">
        <div className="row align-items-center">
          <Common_Title_2 titleText="Crop Solutions" />

          <div className="col-xxl-10 col-xl-10 col-lg-10 col-sm-9">
            <Swiper
              modules={[Navigation]}
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              spaceBetween={15}
              slidesPerView={3}
              navigation={false}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                576: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 5,
                },
              }}
              className="vegetable_swiper"
            >
              {banner?.map((vegetable) => (
                <SwiperSlide key={vegetable.id}>
                  <div
                    className="vegetable_card"
                    onClick={() => handleProductClick(vegetable)}
                  >
                    <div className="vegetable_img">
                      <img
                        src={IDS?.IMG_URL + vegetable.image}
                        alt={vegetable.name}
                      />
                    </div>

                    <div className="vegetable_name">
                      <h4>{vegetable?.name}</h4>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="col-xxl-2 col-xl-2 col-lg-2 col-sm-3 ps-0">
            <div className="swiper_btns_holder">
              <div className="sq1">
                <button
                  type="button"
                  className="category-swiper-prev"
                  ref={prevRef}
                  aria-label="Previous vegetable"
                >
                  <FontAwesomeIcon icon={faAngleLeft} />
                </button>
              </div>

              <div className="sq1 sq2">
                <button
                  type="button"
                  className="category-swiper-next"
                  ref={nextRef}
                  aria-label="Next vegetable"
                >
                  <FontAwesomeIcon icon={faAngleRight} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore_Products;
